import { Component, OnInit, Renderer2, Inject } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['../error.component.scss']
})
export class unauthorizedComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {

  }
}
